///<reference path="../../../../typings/tsd.d.ts" />
///<reference path="../../../bindings/agency-registration/API/Client/api.d.ts" />

module agencyRegistration.service {
    
    export class SearchService {
        _$http: ng.IHttpService
        _$q: ng.IQService
        _api: API.Client.DefaultApi;

        /*@ngInject*/
        constructor($http: ng.IHttpService, $q: ng.IQService) {
            this._$http = $http;
            this._$q = $q;
            this._api = new API.Client.DefaultApi(this._$http);
        };
        
        searchAgency(request): ng.IPromise<API.Client.AgencyReponse> {
            return this._api.agenciesDocumentNumberGet(request).then(response => {
                return response.data;
            });
        };
    }
}
angular.module('agencyRegistrationApp').service('SearchService', agencyRegistration.service.SearchService);